<div class="header">
	<div class="header-title">
		<h1>{{title}}</h1>
	</div>

	<div class="header-actions">
		<ng-container *ngFor="let btn of primaryButtons">
			<button *ngIf="isDesktop" (click)="buttonClick(btn.method)" [style]="btn.style">
				<i *ngIf="btn.icon" [class]="btn.icon" [class.me-2]="btn.text" style="color:white"></i> {{ btn.text }}
			</button>
		</ng-container>
		<div class="sec-header-collapse" *ngIf="!isDesktop">
			<button (click)="toggleActions()" *ngIf="primaryButtons !== undefined">
				<i *ngIf="showActions" class="fal fa-chevron-up" style="color:white; float:right"></i>
				<i *ngIf="!showActions" class="fal fa-chevron-down" style="color:white; float:right"></i>
			</button>
		</div>
	</div>
</div>
<div class="primary-header-wrapper-mobile"
	*ngIf="!isDesktop && showActions && primaryButtons.length > 0">
	<div class="primary-header-mobile">
		<div class="primary-header-actions-mobile" *ngIf="showActions">
			<ng-container *ngFor="let btn of primaryButtons">
				<button (click)="buttonClick(btn.method)" [style]="btn.style">
					<i *ngIf="btn.icon" [class]="btn.icon" [class.me-2]="btn.text" style="color:white"></i> {{ btn.text }}
				</button>
			</ng-container>
		</div>
	</div>
</div>
<!-- Mobile -->
<div class="sec-header-wrapper" [class.collapsed]="!showActions" *ngIf="!isDesktop && showActions && (secondaryButtons.length > 0 || tertiaryButtons.length > 0)">
	<div class="sec-header">
		<div class="primary-header-actions-mobile" *ngIf="showActions">
			<ng-container *ngFor="let btn of tertiaryButtons">
				<button (click)="buttonClick(btn.method)">
					<i *ngIf="btn.icon" [class]="btn.icon" [class.me-2]="btn.text" style="color:white"></i> {{
					btn.text }}
				</button>
			</ng-container>
			<ng-container *ngFor="let btn of secondaryButtons">
				<button (click)="buttonClick(btn.method)" [style]="btn.style">
					<i *ngIf="btn.icon" [class]="btn.icon" [class.me-2]="btn.text" style="color:white"></i> {{
					btn.text }}
				</button>
			</ng-container>
		</div>
	</div>
</div>
<!-- DESKTOP -->
<div class="sec-header-wrapper" [class.collapsed]="!showActions" *ngIf="isDesktop && showActions && (secondaryButtons.length > 0 || tertiaryButtons.length > 0)">
	<div class="sec-header">
		<div class="sec-header-actions" *ngIf="showActions">
			<ng-container *ngFor="let btn of tertiaryButtons">
				<button (click)="buttonClick(btn.method)" [style]="btn.style">
					<i *ngIf="btn.icon" [class]="btn.icon" [class.me-2]="btn.text" style="color:white"></i> {{ btn.text }}
				</button>
			</ng-container>
			<ng-container *ngFor="let btn of secondaryButtons">
				<button (click)="buttonClick(btn.method)" [style]="btn.style">
					<i *ngIf="btn.icon" [class]="btn.icon" [class.me-2]="btn.text" style="color:white"></i> {{ btn.text }}
				</button>
			</ng-container>
		</div>
	</div>
</div>